const formatter = new Intl.DateTimeFormat('ru', {
  timeStyle: 'short',
});

export const formatTime = (time: Date): string | undefined =>
  isNaN(+time) ? undefined : formatter.format(time);
